import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibToggle',
  props: {
    label: {
      type: String,
      required: true
    },
    val: {
      type: [Boolean, Number, String],
      default: false
    },
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      defualt: false
    },
    left: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.color || this.theme.primaryColor
      };
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    }
  }
};